define('core/views/IframeRichMediaView',[
    'underscore',
    'core/mediaConfig',
    'core/views/RichMediaView',
], function (
    _,
    mediaConfig,
    RichMediaView
) {
    'use strict';

    return RichMediaView.extend({
        // IframeRichMediaView displays arbitrary html in the embed.
        // A loader is displayed until the content is ready.

        getMediaDimensions: function () {
            return {
                width: this.media.get('htmlWidth'),
                height: this.media.get('htmlHeight'),
            };
        },

        _findIframe: function ($el) {
            // Locate the iframe element
            // Must be $el or a descendant

            if ($el.is('iframe'))
                return $el;

            return $el.find('iframe');
        },

        configureContentFromActivated: function () {
            RichMediaView.prototype.configureContentFromActivated.apply(this, arguments);

            // If de-activated, the loading div should be hidden
            if (!this.model.get('activated'))
                this.$el.removeClass('media-loading');
        },

        createContentNode: function () {
            var $node = RichMediaView.prototype.createContentNode.apply(this, arguments);

            $node.attr({
                // Always fill width of embed
                width: '100%',
                height: this.model.get('deferredHeight'),
            });

            return $node;
        },

        insertContentNode: function ($node) {
            // Display the loader
            this.loaderNode = this.$el.find('[data-role=content-loader]');
            this.loaderHeight = this.model.get('deferredHeight') ||
                mediaConfig.get('defaultIframeHeight');
            this.loaderNode.height(this.loaderHeight);

            // Hide iframe until loaded
            this.$el.addClass('media-loading');

            // Insert the iframe to start it loading
            RichMediaView.prototype.insertContentNode.call(this, $node);
        },

        prepareElementEvents: function ($node) {
            var $iframe = this._findIframe($node);
            $iframe.one('load', _.bind(this.finishLoad, this, $iframe));
        },

        finishLoad: function ($iframe) {
            // Stop the loader
            this.$el.removeClass('media-loading');
            // Show the iframe
            $iframe.height(this.loaderHeight);
            // Notify listeners of load
            this.trigger('load');
        },
    });
});

